import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-12 px-4 lg:py-12 py-5" }
const _hoisted_2 = { class: "flex flex-row justify-between justify-center items-center lg:px-12 px-3 lg:space-x-6 font-semibold" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "w-1/12 text-gray-500 flex flex-col justify-start items-center text-sm block" }, "Similar jobs", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "border-t-2 border-gray-300 w-full" }, null, -1)
const _hoisted_5 = { class: "flex flex-row justify-center items-center space-x-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "15 18 9 12 15 6" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Previous")
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Next ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("polyline", { points: "9 18 15 12 9 6" })
], -1)
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "w-full"
}
const _hoisted_13 = { class: "grid lg:grid-cols-4 lg:gap-4 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2 animate__animated animate__fadeIn animate__delay-0.4s" }
const _hoisted_14 = { class: "flex flex-row w-full px-12 mt-8 justify-center items-center space-x-3" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "px-8"
}
const _hoisted_17 = { class: "mt-8 px-12 grid lg:grid-cols-4 lg:gap-4 items-center w-full md:grid-cols-2 md:gap-2 sm:grid-cols-2 sm:gap-2 xs:grid-cols-2 xs:gap-2 animate__animated animate__fadeIn animate__delay-0.4s" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BoardCard = _resolveComponent("BoardCard")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", {
          class: _normalizeClass(["flex flex-row justify-center items-center text-sm", 
            _ctx.previous
              ? 'text-primary cursor-pointer'
              : 'text-purple-300 cursor-not-allowed'
          ]),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
        }, _hoisted_8, 2),
        _createElementVNode("span", {
          class: _normalizeClass(["flex flex-row justify-center items-center text-sm", 
            _ctx.next
              ? 'text-primary cursor-pointer'
              : 'text-purple-300 cursor-not-allowed'
          ]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
        }, _hoisted_11, 2)
      ])
    ]),
    (!_ctx.isLoadingJobs)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_BoardCard, { jobs: _ctx.similarJobs }, null, 8, ["jobs"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagination, (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(["w-4 h-4 rounded-full cursor-pointer", _ctx.page === item.page ? 'bg-primary' : 'bg-purple-300']),
                key: index,
                onClick: ($event: any) => (_ctx.changePageSimilar(item.page))
              }, null, 10, _hoisted_15))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([0, 1, 2, 3], (item, index) => {
              return _createElementVNode("div", { key: index }, [
                _createVNode(_component_SkeletonCard)
              ])
            }), 64))
          ])
        ]))
  ]))
}